import { AAHASearchUrl, Links } from '@/lib/constants';
import syringe from '../../assets/images/syringe.svg';
import styles from './EmptyChipList.module.scss';
import { isValidThirdPartySerialNumber } from '@barkinglabs/nano-shared';
import { useHistory } from 'react-router-dom';

interface EmptyChipListProps {
  query?: string;
  searchMode?: boolean;
  isExistingChip?: boolean;
  isVerifiedReseller?: boolean;
  onReassignClick?: () => void;
  onRegisterClick?: () => void;
}

export default function EmptyChipList({
  query = '',
  searchMode = false,
  isExistingChip = false,
  isVerifiedReseller = false,
  onReassignClick,
  onRegisterClick,
}: EmptyChipListProps) {
  const showCheckOtherRegistriesButton = isValidThirdPartySerialNumber(query);
  const history = useHistory();
  return (
    <main className={styles.main}>
      <section className={styles.emptyChipList}>
        <img src={syringe} alt="No chips Found" aria-hidden="true" role="presentation" />
        {searchMode ? (
          <>
            {!isExistingChip && (
              <>
                <h2>No results found for: {query}</h2>
                {query.length < 3 ? (
                  <p>Please type at least 3 characters to search</p>
                ) : (
                  <p>It doesn't look like you have anything matching that search linked to your organization.</p>
                )}
              </>
            )}
            {showCheckOtherRegistriesButton && !isExistingChip && (
              <>
                <p className={styles.registerPrompt}>
                  This wasn't detected as a Fi Nano. Add it to your stock to register it to a pet later.
                </p>
                <div>
                  {onRegisterClick && <button onClick={onRegisterClick}>Add to Stock</button>}
                  <button className={styles.secondary}>
                    <a href={AAHASearchUrl(query)} target="_blank" rel="noopener noreferrer">
                      Check Other Registries
                      <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 19H5V5H12V3H3V21H21V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"></path>
                      </svg>
                    </a>
                  </button>
                </div>
              </>
            )}
            {isExistingChip && (
              <>
                <h2>1 result found for: {query}</h2>
                <p>Chip is currently linked to another organization.</p>
                <div>
                  <button onClick={() => history.push(Links.search(query))}>View Chip</button>
                  {isVerifiedReseller && onReassignClick && <button onClick={onReassignClick}>Reassign Chip</button>}
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <h2>Nothing here yet</h2>
            <p>Your chips will be shown here once they are available.</p>
          </>
        )}
      </section>
    </main>
  );
}
